module.exports = __webpack_public_path__ + "static/img/jp2.6923dfcd.png";